import { AgentTypeName } from '@/enums';
import { getRouteSectionContent } from '@/helpers/ContentHelper';
import { useAppSelector } from '@/hook';
import { useGoogleAnalytic } from '@/hooks/useGoogleAnalytic';
import { useInsuranceRoute } from '@/hooks/useRouteSection';
import EGIBlogo from '@/images/Etiqa-EGIB.png';
import EGTBlogo from '@/images/Etiqa-EGTB.png';
import MBBlogo from '@/images/MBB-logo.png';
import { devices } from '@/theme/device';
import { withPrefixImage } from '@/utility/withPrefix';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import styled from 'styled-components';
import LanguageSwitcher from '../common/LanguageSwitcher';

const Header = () => {
  const isInsurance = useInsuranceRoute();
  const affiliateState = useAppSelector((state) => state.affiliate);
  const googleAnalytic = useGoogleAnalytic();

  const handleLogoClickEvent = () => {
    googleAnalytic.goToHome();
    window.location.href = 'https://www.etiqa.com.my';
  };

  const trackLanguageChange = (newLanguage: string) => {
    googleAnalytic.selectLanguage(newLanguage);
  };

  const AffiliateSection = () => {
    return affiliateState.type === AgentTypeName.Banca ? (
      <AffiliateInfo>
        <span>Branch Code : {affiliateState.bancaBranchCode}</span>
        <br />
        <span>PF Number : {affiliateState.salesPfNumber}</span>
      </AffiliateInfo>
    ) : (
      <AffiliateInfo>
        <span>Agent Code : {affiliateState.agentCode}</span>
        <br />
        <span>Agent Branch Code : {affiliateState.agentBranchCode}</span>
      </AffiliateInfo>
    );
  };

  return (
    <StylesNavbar isBanca={affiliateState.type === AgentTypeName.Banca}>
      <Container>
        <StylesLogo>
          <Navbar.Brand onClick={handleLogoClickEvent}>
            <Logo
              src={withPrefixImage(
                !(affiliateState.type === AgentTypeName.Banca)
                  ? isInsurance
                    ? EGIBlogo
                    : EGTBlogo
                  : MBBlogo,
              )}
              alt="Logo"
            />
          </Navbar.Brand>
        </StylesLogo>
        <Navbar.Toggle />
        <StylesTitle>{getRouteSectionContent(`header.takaful`)}</StylesTitle>
        <Styleslanguage>
          <Navbar.Collapse className="justify-content-end">
            {affiliateState.isValid ? <AffiliateSection /> : <></>}
            <LanguageSwitcher />
          </Navbar.Collapse>
        </Styleslanguage>
      </Container>
    </StylesNavbar>
   
  );
};

export default Header;

const StylesNavbar = styled(Navbar)<{ isBanca?: boolean }>`
  background-color: ${(props) => (props.isBanca ? 'rgb(252, 196, 12); !important' : '#f8f9fa')};
`;
const StylesLogo = styled.a`
  @media only screen and ${devices.xs} {
    flex: 0;
  }
  @media only screen and ${devices.lg} {
    flex: 1;
  }
`;

const StylesTitle = styled(Navbar.Text)`
  flex: 1;
  text-align: center;
  font-weight: 700 !important;
  color: #000 !important;
  font-size: ${(props: any) => props.theme.smallScreenBodyText2};
  @media only screen and ${devices.xs} {
    display: none;
  }
  @media only screen and ${devices.lg} {
    display: block;
  }
`;

const Styleslanguage = styled.div`
  flex: 1;
`;

const AffiliateInfo = styled.div`
  margin: 0.25rem 0rem;
  font-szie: ${(props: any) => props.theme.smallScreenDetails};
`;

const Logo = styled.img`
  height: 45px;
  margin-right: 5%;

  @media only screen and ${devices.xs} {
    height: 40px;
  }

  @media only screen and ${devices.lg} {
    height: 45px;
  }
`;
